import { StoreCheckout } from "../../components/checkout/Checkout.types";
import { SubscriptionPlan, UserInfo } from "../../components/signup/SignUpApi";
import facebookPixel from "./facebookPixel";
import googleAds from "./googleAds";
import { mixPanelInstance } from "./mixpanel";
import tiktokPixel from "./tiktokPixel";
import { TrackedProduct } from "./types";

export function trackSubscribe(plan: SubscriptionPlan, userInfo?: UserInfo) {
  facebookPixel.trackSubscribe(plan, userInfo);
  tiktokPixel.trackSubscribe(plan, userInfo);
  googleAds.trackSubscribe(plan);
}

export function trackPurchase(checkout: StoreCheckout, userInfo: UserInfo | undefined) {
  if (checkout == null || userInfo == null) {
    return;
  }
  const { referral } = userInfo;
  const utmSource = referral?.split("|")[0] ?? "";
  facebookPixel.trackPurchase(checkout, userInfo);
  tiktokPixel.trackPurchase(checkout, userInfo);
  googleAds.trackPurchase(checkout);
  if (utmSource !== "") {
    mixPanelInstance.trackUTMStorePurchase(utmSource);
  }
}

export function trackLogin(userInfo?: UserInfo) {
  if (userInfo) {
    facebookPixel.trackLogin(userInfo);
  }
}

/**
 * The funnel events above the purchase.
 *
 * Facebook and TikTok report the same set, so the two pixels optimise on the
 * same funnel. Google Ads takes only the conversions it has a label for.
 */
export function trackViewContent(product: TrackedProduct) {
  facebookPixel.trackViewContent(product);
  tiktokPixel.trackViewContent(product);
}

export function trackAddToCart(product: TrackedProduct) {
  facebookPixel.trackAddToCart(product);
  tiktokPixel.trackAddToCart(product);
}

export function trackInitiateCheckout(checkout: StoreCheckout) {
  if (checkout == null) {
    return;
  }
  facebookPixel.trackInitiateCheckout(checkout);
  tiktokPixel.trackInitiateCheckout(checkout);
}

/** A signup reaching its end — the acquisition conversion, not a sale. */
export function trackCompleteRegistration(userInfo?: UserInfo) {
  facebookPixel.trackCompleteRegistration(userInfo);
  tiktokPixel.trackCompleteRegistration(userInfo);
  googleAds.trackCompleteRegistration();
}
